import { createFileRoute } from '@tanstack/react-router'
import { SuppliersPage } from '@/pages/suppliers'

export const Route = createFileRoute('/_authenticated/suppliers/')({
  staticData: { title: 'Suppliers' },
  component: SuppliersPage,
})
